import React, { FunctionComponent } from 'react';

import TopNav from '@/features/navigation/topNav';

export type DrawMode = 'polygon' | 'rectangle' | 'circle';

const TopNavigation: FunctionComponent = () => {
  return <TopNav />;
};

export default TopNavigation;
